import React, { Component } from 'react'
import Button from 'components/UI/Button/Button'
import YesNoPopup from 'modules/dashboard/DashboardPopup/YesNoPopup/YesNoPopup'
import CreateNewClassPopup from 'modules/dashboard/DashboardPopup/CreateNewClassPopup/CreateNewClassPopup'
import {
  ArchiveWrapper,
  InfoText,
  ArchivedClasses,
  Title,
  ArchivedClass
} from './ArchiveClass.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class ArchiveClass extends Component {
  constructor (props) {
    super(props)

    this.createNewClass = this.createNewClass.bind(this)
    this.renderArchivedClasses = this.renderArchivedClasses.bind(this)
  }

  createNewClass () {
    this.props.modal.open(
      <YesNoPopup
        isSettings
        question='Are you sure you want to create a new class?'
        footnote='Creating a new class is commonly done at the start of a school year. You will be able to access your archived classes work still.'
        onCancel={this.props.modal.closeAll}
        onConfirm={() => {
          this.props.modal.open(
            <CreateNewClassPopup
              onCancel={this.props.modal.closeAll}
              onConfirm={(newgroup) => {
                newgroup.nbStudents = parseInt(newgroup.nbStudents)
                this.props.createNewGroup(newgroup, this.props.teacher._id)
                  .then(() => {
                    location.reload()
                  })
              }}
            />
          )
        }}
      />
    )
  }

  switchClasses (c) {
    this.props.modal.open(
      <YesNoPopup
        isSettings
        question={`Switch to ${c.name}?`}
        footnote='You will need to switch back to view your previous class.'
        onCancel={this.props.modal.closeAll}
        onConfirm={() => {
          this.props.changeActiveGroup(c._id)
            .then(() => {
              location.reload()
            })
        }}
      />
    )
  }

  renderArchivedClasses () {
    let classes = this.props.archivedClasses.slice().reverse().map((c, i) => {
      let date = new Date(c.createdAt)
      return (<ArchivedClass key={i} onClick={() => this.switchClasses(c)}>{c.name} - {c.students.count} students - {date.toLocaleDateString() || ''} (Switch back)</ArchivedClass>)
    })

    return (
      <ArchivedClasses>
        <Title>Archived Classes</Title>
        {classes}
      </ArchivedClasses>

    )
  }

  render () {
    return (
      <ArchiveWrapper>
        <Button
          bgColor='#88B81D'
          color='white'
          onClick={this.createNewClass}
          size='regular'
        >
          {'CREATE NEW CLASS'}
        </Button>
        <InfoText>
          (Create a new class and manage archived classes)
        </InfoText>
        {this.props.archivedClasses && this.props.archivedClasses.length > 0 &&
          this.renderArchivedClasses()
        }
      </ArchiveWrapper>
    )
  }
}
